export const RISK_LIKELIHOODS = [
    'Rare',
    'Unlikely',
    'Possible',
    'Likely',
    'Almost Certain'
];
